import { useCollection } from "@/api/hooks";
import { Button } from "../button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../dialog";
import { useDeleteCollectionMutation } from "@/api/api";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function CollectionDeleteDialog() {
  const [open, setOpen] = useState(false);
  const [deleteCollection] = useDeleteCollectionMutation();
  const collection = useCollection();
  const navigate = useNavigate();

  if (!collection) return;

  const handleDelete = () => {
    deleteCollection(collection.id);

    setOpen(false);
    navigate("/");
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" className="w-full">Delete collection</Button>
      </DialogTrigger>
      <form onSubmit={(e) => e.preventDefault()}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Delete collection</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-2">
            <p>
              Are you sure you want to delete collection
              <span className="font-semibold">{" " + collection.title}</span>?
            </p>
            {/* Deleting a collection deletes the records filed in it. Its title
                record is not one of them — it never belonged here — so it is
                the one thing that survives, and saying so avoids the opposite
                assumption. */}
            {collection.title_record_id && (
              <p className="text-[13px] text-muted-foreground">
                Its records go with it. The title record does not — it is not
                filed in this collection, so it stays on the timeline.
              </p>
            )}
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">Cancel</Button>
            </DialogClose>
            <Button type="submit" variant="destructive" onClick={handleDelete}>
              Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </form>
    </Dialog>
  );
}
